(() => {
  const root = document.querySelector('[data-cls]');
  if (!root) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const menu = root.querySelector('[data-cls-menu]');
  const nav = root.querySelector('#cls-nav');
  menu?.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    menu.setAttribute('aria-expanded', String(open));
    menu.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
  });
  nav?.addEventListener('click', (event) => {
    if (event.target.closest('a')) {
      nav.classList.remove('is-open');
      menu?.setAttribute('aria-expanded', 'false');
    }
  });

  const slides = [...root.querySelectorAll('[data-cls-star-slide]')];
  const star = root.querySelector('[data-cls-star]');
  const count = root.querySelector('[data-cls-star-count]');
  let active = slides.length ? Math.floor(Math.random() * slides.length) : 0;
  let starTimer;
  let starVisible = true;
  let starPaused = false;
  function showStar(index) {
    if (!slides.length) return;
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const selected = i === active;
      slide.classList.toggle('is-active', selected);
      slide.setAttribute('aria-hidden', String(!selected));
      slide.querySelectorAll('a').forEach((link) => link.tabIndex = selected ? 0 : -1);
    });
    if (count) count.textContent = `${active + 1} / ${slides.length}`;
  }
  function updateStarTimer() {
    clearInterval(starTimer);
    if (!reduced.matches && !document.hidden && starVisible && !starPaused && slides.length > 1) {
      starTimer = setInterval(() => showStar(active + 1), 8500);
    }
  }
  showStar(active);
  root.querySelector('[data-cls-star-prev]')?.addEventListener('click', () => { showStar(active - 1); updateStarTimer(); });
  root.querySelector('[data-cls-star-next]')?.addEventListener('click', () => { showStar(active + 1); updateStarTimer(); });
  star?.addEventListener('mouseenter', () => { starPaused = true; updateStarTimer(); });
  star?.addEventListener('mouseleave', () => { starPaused = false; updateStarTimer(); });
  star?.addEventListener('focusin', () => { starPaused = true; updateStarTimer(); });
  star?.addEventListener('focusout', (event) => { if (!star.contains(event.relatedTarget)) { starPaused = false; updateStarTimer(); } });
  if ('IntersectionObserver' in window && star) {
    new IntersectionObserver(([entry]) => { starVisible = entry.isIntersecting; updateStarTimer(); }, { threshold: .15 }).observe(star);
  }
  document.addEventListener('visibilitychange', updateStarTimer);
  reduced.addEventListener?.('change', updateStarTimer);
  updateStarTimer();

  const reveal = [...root.querySelectorAll('.cls-reveal')];
  if ('IntersectionObserver' in window && !reduced.matches) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { rootMargin: '0px 0px -40px 0px', threshold: .08 });
    reveal.forEach((element) => observer.observe(element));
  } else reveal.forEach((element) => element.classList.add('is-visible'));

  const rail = root.querySelector('[data-cls-products-rail]');
  const next = () => rail?.scrollBy({ left: rail.querySelector('.cls-card')?.getBoundingClientRect().width + 13 || 200, behavior: reduced.matches ? 'instant' : 'smooth' });
  const prev = () => rail?.scrollBy({ left: -(rail.querySelector('.cls-card')?.getBoundingClientRect().width + 13 || 200), behavior: reduced.matches ? 'instant' : 'smooth' });
  root.querySelector('[data-cls-products-next]')?.addEventListener('click', next);
  root.querySelector('[data-cls-products-prev]')?.addEventListener('click', prev);
  let railTimer;
  let railVisible = false;
  let railPaused = false;
  function updateRailTimer() {
    clearInterval(railTimer);
    if (!rail || reduced.matches || document.hidden || !railVisible || railPaused) return;
    railTimer = setInterval(() => {
      const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 12;
      rail.scrollTo({ left: atEnd ? 0 : rail.scrollLeft + (rail.querySelector('.cls-card')?.getBoundingClientRect().width || 185) + 13, behavior: 'smooth' });
    }, 6200);
  }
  if (rail && 'IntersectionObserver' in window) new IntersectionObserver(([entry]) => { railVisible = entry.isIntersecting; updateRailTimer(); }, { threshold: .3 }).observe(rail);
  rail?.addEventListener('mouseenter', () => { railPaused = true; updateRailTimer(); });
  rail?.addEventListener('mouseleave', () => { railPaused = false; updateRailTimer(); });
  rail?.addEventListener('focusin', () => { railPaused = true; updateRailTimer(); });
  rail?.addEventListener('focusout', (event) => { if (!rail.contains(event.relatedTarget)) { railPaused = false; updateRailTimer(); } });
  document.addEventListener('visibilitychange', updateRailTimer);
  reduced.addEventListener?.('change', updateRailTimer);

  const form = root.querySelector('[data-cls-search-form]');
  const input = root.querySelector('[data-cls-search-input]');
  const suggestions = root.querySelector('[data-cls-suggest]');
  const status = root.querySelector('[data-cls-search-status]');
  const fileInput = root.querySelector('[data-cls-photo-file]');
  if (matchMedia('(max-width: 760px)').matches) input.placeholder = '¿Qué buscas hoy?';
  let searchTimer;
  let searchController;
  let requestNumber = 0;
  const money = (amount) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(amount) || 0);
  const setStatus = (message) => { status.textContent = message; };
  function closeSuggestions() { suggestions.hidden = true; suggestions.replaceChildren(); }
  const searchPath = new URL(form.action, location.href).pathname.replace(/search\/?$/, 'search/suggest.json');
  async function searchProducts(query) {
    const current = ++requestNumber;
    searchController?.abort();
    if (query.trim().length < 2) { closeSuggestions(); return; }
    searchController = new AbortController();
    const url = new URL(searchPath, location.origin);
    url.searchParams.set('q', query.trim());
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '5');
    try {
      const response = await fetch(url, { signal: searchController.signal });
      if (!response.ok) throw new Error('search unavailable');
      const data = await response.json();
      if (current !== requestNumber) return;
      const products = data.resources?.results?.products || [];
      suggestions.replaceChildren();
      products.forEach((product) => {
        const link = document.createElement('a');
        link.href = product.url;
        if (product.featured_image?.url) {
          const img = document.createElement('img');
          img.src = product.featured_image.url;
          img.alt = '';
          img.loading = 'lazy';
          link.append(img);
        }
        const copy = document.createElement('span');
        const title = document.createElement('strong');
        title.textContent = product.title;
        const price = document.createElement('small');
        price.textContent = money(product.price);
        copy.append(title, price); link.append(copy); suggestions.append(link);
      });
      suggestions.hidden = products.length === 0;
      if (!products.length) setStatus('No encontramos coincidencias. Prueba otra palabra o abre la búsqueda completa.');
      else if (status.textContent.startsWith('No encontramos')) setStatus('');
    } catch (error) { if (error.name !== 'AbortError' && current === requestNumber) { closeSuggestions(); setStatus('No se pudieron cargar sugerencias. Puedes buscar con Enter.'); } }
  }
  input?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const query = input.value;
    if (query.trim().length < 2) { requestNumber++; searchController?.abort(); closeSuggestions(); return; }
    searchTimer = setTimeout(() => searchProducts(query), 230);
  });
  input?.addEventListener('focus', () => { if (input.value.trim().length > 1) searchProducts(input.value); });
  document.addEventListener('click', (event) => { if (!form.contains(event.target) && !suggestions.contains(event.target)) closeSuggestions(); });
  input?.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSuggestions(); });

  const VoiceRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  let recognition;
  root.querySelector('[data-cls-voice]')?.addEventListener('click', () => {
    if (!VoiceRecognition) { setStatus('La búsqueda por voz no está disponible en este navegador. Escribe tu búsqueda.'); input.focus(); return; }
    try {
      recognition?.abort();
      recognition = new VoiceRecognition();
      recognition.lang = 'es-MX';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;
      recognition.onstart = () => setStatus('Escuchando… Di el producto que buscas.');
      recognition.onresult = (event) => {
        const transcript = event.results[0]?.[0]?.transcript?.trim();
        if (transcript) { input.value = transcript; setStatus(`Buscando: ${transcript}`); searchProducts(transcript); }
      };
      recognition.onerror = () => setStatus('No se pudo reconocer la voz. Prueba de nuevo o escribe tu búsqueda.');
      recognition.onend = () => { if (status.textContent.startsWith('Escuchando')) setStatus('No escuchamos una búsqueda. Prueba de nuevo.'); };
      recognition.start();
    } catch { setStatus('No se pudo iniciar el micrófono. Revisa el permiso del navegador.'); }
  });

  root.querySelector('[data-cls-photo]')?.addEventListener('click', () => fileInput?.click());
  const loadTesseract = () => new Promise((resolve, reject) => {
    if (window.Tesseract) { resolve(window.Tesseract); return; }
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/tesseract.js@6.0.1/dist/tesseract.min.js';
    script.async = true;
    script.onload = () => window.Tesseract ? resolve(window.Tesseract) : reject(new Error('OCR unavailable'));
    script.onerror = () => reject(new Error('OCR unavailable'));
    document.head.append(script);
  });
  const usefulWords = (text) => {
    const words = text.toUpperCase().match(/[A-ZÁÉÍÓÚÑ][A-ZÁÉÍÓÚÑ0-9-]{3,}/g) || [];
    const preferred = ['BRAVECTO', 'SIMPARICA', 'NEXGARD', 'SERESTO', 'ROYAL', 'CANIN', 'HILLS', 'PURINA', 'VIRBAC', 'FELIWAY', 'NUPEC'];
    const match = preferred.find((word) => words.includes(word));
    if (match) return match === 'ROYAL' && words.includes('CANIN') ? 'Royal Canin' : match;
    const ignored = new Set(['PARA', 'PERRO', 'PERROS', 'GATO', 'GATOS', 'TABLETAS', 'CONTENIDO', 'NETO', 'SALUD', 'CUIDADO', 'PRODUCTO']);
    return words.find((word) => !ignored.has(word) && word.length >= 5) || '';
  };
  fileInput?.addEventListener('change', async () => {
    const file = fileInput.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) { setStatus('Selecciona una foto del empaque del producto.'); return; }
    setStatus('Leyendo texto o código del empaque en tu dispositivo…');
    try {
      let query = '';
      if ('BarcodeDetector' in window) {
        try { const codes = await new BarcodeDetector().detect(file); query = codes[0]?.rawValue || ''; } catch { /* OCR is the fallback. */ }
      }
      if (!query) {
        const Tesseract = await loadTesseract();
        const worker = await Tesseract.createWorker('eng');
        try { const result = await worker.recognize(file); query = usefulWords(result.data?.text || ''); }
        finally { await worker.terminate(); }
      }
      if (query) { input.value = query; setStatus(`Encontramos “${query}”. Revisa los resultados.`); await searchProducts(query); input.focus(); }
      else setStatus('No detectamos texto o código legible. Fotografía de frente el nombre del empaque o escribe el producto.');
    } catch { setStatus('No pudimos leer esta foto. Prueba una imagen nítida del empaque o escribe el nombre.'); }
    finally { fileInput.value = ''; }
  });
})();
